import { UserCanceled } from "../../util/CustomErrors";
import { getSafe } from "../../util/storeHelper";
import { makeQueue, setdefault } from "../../util/util";
import BrowserView from "./views/BrowserView";
import { closeBrowser, showURL } from "./actions";
import { sessionReducer } from "./reducers";
import PromiseBB from "bluebird";
import { ipcRenderer } from "electron";
import { generate as shortid } from "shortid";
const subscriptions = {};
function subscribe(subscriber, eventId, callback) {
    setdefault(setdefault(subscriptions, subscriber, {}), eventId, []).push(callback);
}
function unsubscribeAll(subscriber) {
    delete subscriptions[subscriber];
}
function triggerEvent(subscriber, eventId, ...args) {
    let res = "continue";
    getSafe(subscriptions, [subscriber, eventId], []).forEach((sub) => {
        if (res === "continue") {
            res = sub(...args);
        }
    });
    return res;
}
let lastURL;
function doBrowse(api, navUrl, instructions, subscriptionId, skippable) {
    return new PromiseBB((resolve, reject) => {
        lastURL = navUrl;
        subscribe(subscriptionId, "close", (skip) => {
            reject(new UserCanceled(skip));
            return "continue";
        });
        subscribe(subscriptionId, "navigate", (newUrl) => {
            lastURL = newUrl;
            return "continue";
        });
        subscribe(subscriptionId, "download-url", (download) => {
            resolve(download);
            return "close";
        });
        if (instructions === undefined) {
            instructions = "";
        }
        if (instructions.length > 0) {
            instructions += "\n\n";
        }
        const t = api.translate;
        instructions += t("This window will close as soon as you click a valid download link");
        api.store.dispatch(showURL(navUrl, instructions, subscriptionId, skippable));
    })
        .catch((err) => {
        if (err instanceof UserCanceled) {
            if (skippable) {
                return "err:" + (err.skipped ? "skip" : "cancel");
            }
            else {
                return null;
            }
        }
        api.showErrorNotification("Failed to download via browser", err);
    })
        .finally(() => {
        unsubscribeAll(subscriptionId);
    });
}
function init(context) {
    context.registerReducer(["session", "browser"], sessionReducer);
    const onNavigate = (navUrl) => {
        lastURL = navUrl;
    };
    context.registerDialog("browser", BrowserView, () => ({
        onEvent: triggerEvent,
        onNavigate,
        overlay: false,
    }));
    context.once(() => {
        const enqueue = makeQueue();
        // open a browser to an url, displaying instructions if provided.
        // the browser closes as soon as a downloadable link was clicked and returns that
        // url
        context.api.onAsync("browse-for-download", (navUrl, instructions, skippable) => {
            return enqueue(() => doBrowse(context.api, navUrl, instructions, shortid(), skippable ?? false), false);
        });
        ipcRenderer.on("received-url", (evt, dlUrl, fileName) => {
            try {
                const parsed = new URL(dlUrl);
                if (parsed.pathname === null) {
                    // invalid url, not touching this
                    return;
                }
            }
            catch {
                // invalid url, not touching this
                return;
            }
            if (dlUrl.startsWith("blob:")) {
                dlUrl += "|" + fileName;
            }
            if (lastURL !== undefined) {
                dlUrl += "<" + lastURL;
            }
            const state = context.api.store.getState();
            const { subscriber } = state.session.browser;
            if (subscriber !== undefined) {
                const res = triggerEvent(subscriber, "download-url", dlUrl);
                if (res === "close") {
                    context.api.store.dispatch(closeBrowser());
                }
            }
            else {
                context.api.events.emit("start-download-url", dlUrl);
            }
        });
    });
    return true;
}
export default init;
